<script>
import { mapGetters } from 'vuex'
import actions from './actions'
import Roles from '@/mixins/Roles'
export default {
    mixins: [actions, Roles],

    computed: mapGetters({ address: 'address' }),
}
</script>

<template lang="pug">
acrm-panel
    .row
        .col-md-12
            acrm-hidden-input.mb-3(v-model="address.address" @save="save")
                label {{ $t('ADDRESSES.ADDRESS')}}
                div {{ address.address }}
                acrm-input-google-autocomplete(:disabled="!hasRoleUpdate('address.fields.address')" slot="edit" v-model="address.address" :placeholder="$t('ADDRESSES.ADDRESS')" wide)
        .col-md-12
            .mb-3.w-100
                acrm-input-google-map-location(v-model="address.location")
</template>
